import { useCallback, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import LopHanhChinhTreeView from '../../../components/lop-tree-view/LopHanhChinhTreeView';
import { PlaceHolder } from '../../../components/place-holder';
import { useCommonSelectedHook } from '../../../hooks/useCommonSelectedHook';
import { ePageBaseStatus } from '../../../models/ePageBaseStatus';
import { actions } from '../../../state/actions/actionsWrapper';
import { RootState } from '../../../state/reducers';
import { ILopSelected } from '../LopHanhChinhPage';
import styles from './LopListContainer.module.css';
import { ILopSelectedItemRequest } from '../../../models/request/danh-muc/ILopSelectedItemRequest';

interface ILopListContainerProps {
	lopSelected: ILopSelected;
	setLopSelected: (lopSelected: ILopSelected) => void;
}

const LopListContainer = (props: ILopListContainerProps) => {
	const dispatch = useDispatch();
	const { nam_hoc, dm_truong_selected_id, dm_he_selected_id } = useSelector((x: RootState) => x.common);
	const { dm_coso_id } = useCommonSelectedHook();

	const { lopSelected, setLopSelected } = props;
	const { status, treeViewItems } = useSelector((x: RootState) => x.danhMucWrapper.lop);
	const [lopEditId, setLopEditId] = useState<number>(0);
	const handleReloadLopHanhChinhs = useCallback(() => {
		dispatch(
			actions.danhMucWrapper.lop.loadTreeCteStart({
				nam_hoc: nam_hoc,
				dm_truong_id: dm_truong_selected_id,
				dm_he_id: dm_he_selected_id,
				dm_khoi_id: 0,
				dm_coso_id: dm_coso_id
			})
		);
	}, [nam_hoc, dm_coso_id]);
	useEffect(() => {
		handleReloadLopHanhChinhs();
	}, [nam_hoc, dm_coso_id]);
	useEffect(() => {
		if (status == ePageBaseStatus.is_need_reload) {
			handleReloadLopHanhChinhs();
			setLopSelected({ dm_lop: {} as ILopSelectedItemRequest, ten_lop: '' });
		}
	}, [status]);
	return (
		<div className={styles.container}>
			{status == ePageBaseStatus.is_loading ? (
				<PlaceHolder line_number={10} />
			) : (
				<LopHanhChinhTreeView
					dataSource={treeViewItems}
					nam_hoc={nam_hoc}
					dm_truong_id={dm_truong_selected_id}
					selectedValue={lopSelected.dm_lop}
					onSelectionChanged={(data: ILopSelectedItemRequest, ten_lop?: string) => {
						setLopSelected({
							dm_lop: data,
							ten_lop: ten_lop ?? '',
						});
						setLopEditId(data.dm_lop_id);
					}}
				/>
			)}
		</div>
	);
};

export default LopListContainer;
